import React from "react";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { Building2, Eye } from "lucide-react";
import { createPageUrl } from "@/shared/utils";
import { Badge } from "@/shared/components/ui/badge";
import { Button } from "@/shared/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/shared/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/shared/components/ui/table";

export default function MerchantsTab({ merchants, statusConfig, t }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("merchants")} ({merchants.length})</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <Table className="min-w-[700px]">
            <TableHeader>
              <TableRow>
                <TableHead>{t("merchant")}</TableHead>
                <TableHead>{t("code")}</TableHead>
                <TableHead>{t("status")}</TableHead>
                <TableHead>{t("fee")}</TableHead>
                <TableHead>{t("created")}</TableHead>
                <TableHead></TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {merchants.map(merchant => (
                <TableRow key={merchant.id} className="cursor-pointer hover:bg-slate-50">
                  <TableCell>
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 rounded-lg bg-blue-100 flex items-center justify-center">
                        <Building2 className="h-4 w-4 text-blue-600" />
                      </div>
                      <div>
                        <p className="font-medium">{merchant.name}</p>
                        <p className="text-sm text-slate-500">{merchant.contact_email}</p>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell>
                    <Badge variant="outline">{merchant.code}</Badge>
                  </TableCell>
                  <TableCell>
                    <Badge className={statusConfig[(merchant.status || "").toLowerCase()]?.color || "bg-slate-100 text-slate-700"}>
                      {t((merchant.status || "").toLowerCase())}
                    </Badge>
                  </TableCell>
                  <TableCell>{merchant.fee_value}{merchant.fee_type === "percentage" ? "%" : " PKR"}</TableCell>
                  <TableCell className="text-slate-500">
                    {merchant.created_date ? format(new Date(merchant.created_date), "MMM d, yyyy") : t("nA")}
                  </TableCell>
                  <TableCell>
                    <Link to={createPageUrl("AdminMerchantDetail") + `?id=${merchant.id}`}>
                      <Button variant="ghost" size="icon"><Eye className="h-4 w-4" /></Button>
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
}
